import React, { useContext } from 'react';
import useFetch from 'use-http';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import Dialog from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Acknowledgement from 'src/models/leasing/Acknowledgement';

interface IDeleteAcknowledgementDialogProps {
    acknowledgement?: Acknowledgement;
    onCloseDialog?: () => void;
    refreshLease?: (data: boolean) => void;
}

const DeleteAcknowledgementDialog = (props: IDeleteAcknowledgementDialogProps) => {
    const { del } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const deleteAcknowledgement = async (ack: Acknowledgement) => {
        console.log('deleting acknowledgement, ', ack);

        try {
            await del(
                `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contractGeneration/acknowledgement/${ack?.id}`
            );
            props.refreshLease(true);

        } catch (e) {
            console.log('Failed to Delete Acknowledgement!, ', e);
        }
    };

    const handleSubmitAction = () => {
        deleteAcknowledgement(props?.acknowledgement);
        props.onCloseDialog();
    };

    const handleCancelAction = () => {
        props.onCloseDialog();
    };

    return (
        <Dialog title="Delete Acknowledgement">
            <h3>Confirm the next action:</h3>
            <div style={{ margin: '3rem 0', textAlign: 'center' }}>
                <p>{`Deleting Acknowledgement: #${props?.acknowledgement?.id}`}</p>
            </div>
            <div style={{ display: 'flex', gap: '2rem' }}>
                <Button text="Submit" intent="primary" onClick={handleSubmitAction} />
                <Button text="Cancel" onClick={handleCancelAction} />
            </div>
        </Dialog>
    );
};

export default DeleteAcknowledgementDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/DeleteAcknowledgementDialog.tsx